.error {
  flex: 1;
  width: 100%;
  height: 100%;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  
  .errorMessage {
    max-width: 700px;
  }

  svg {
    cursor: default;
    width: 20px;
    height: 20px;
    margin-bottom: 10px;
    flex-shrink: 0;
  }

  .tryAgain {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    margin-top: 5px;

    @include themify($themes) {
      color: themed('neutral-primary');
    }
  }
}
